export const GET_SPECIFIC_SEARCH_LIST = "GET_SPECIFIC_SEARCH_LIST"
export const GET_SPECIFIC_SEARCH_LIST_SUCCESS = "GET_SPECIFIC_SEARCH_LIST_SUCCESS"
export const DOWN_SPECIFIC_SEARCH_EXCEL = "DOWN_SPECIFIC_SEARCH_EXCEL"
export const DOWN_SPECIFIC_SEARCH_EXCEL_SUCCESS = "DOWN_SPECIFIC_SEARCH_EXCEL_SUCCESS"
export const DOWN_SPECIFIC_SEARCH_PDF = "DOWN_SPECIFIC_SEARCH_PDF"
export const DOWN_SPECIFIC_SEARCH_PDF_SUCCESS = "DOWN_SPECIFIC_SEARCH_PDF_SUCCESS"
export const CLEAR_SPECIFIC_SEARCH = "CLEAR_SPECIFIC_SEARCH"
